// extracted by mini-css-extract-plugin
module.exports = {"root":"DLMerchRequestSuccess_root__oN4ac","image":"DLMerchRequestSuccess_image__hMyaa","link":"DLMerchRequestSuccess_link__Bb9cN"};